import SVG from "react-inlinesvg";
import { useState } from "react";
import InputWithFix from "app/common/components/InputWithFix";
import CustomPopover from "app/common/components/CustomPopover";
import { debounce } from "app/common/util/Helpers";

const CustomInputAutoComplete = ({onSelect, isLoading, options, formatOpt, sameWidth = false, withToolTip = true, ...props}) => {

    const [revealPopOver, setRevealPopOver] = useState(false);

    return  <CustomPopover
                sameWidth={sameWidth}
                offset={[0, withToolTip ? 18 : 5]}
                withToolTip={options?.length > 0 && withToolTip}
                revealPopOver={revealPopOver}
            >
                <button
                    className="block w-full"
                    type="button"
                >
                    <InputWithFix 
                        {...props} 
                        autoComplete="off"
                        onFocus={_ => setRevealPopOver(true)}
                        onBlur={debounce(e => { setRevealPopOver(false); props.onBlur?.(e)}, 500)}
                        affix={ isLoading && (props.affix || <SVG
                                src="/assets/media/svg/spinner.svg"
                                className={`inline-block splash-spinner  mx-auto h-5 w-5 stroke-primary}`}
                            />)}    
                    />
                </button>
                <div
                    className="opt-cont divide-y divide-grey-1 text-black-1 dark:divide-dark-1 rounded-xl"
                >
                {
                    options?.map?.((item, i) =>
                        <button
                            type='button'
                            className={`text-sm w-full text-left hover:bg-grey-1 ${!formatOpt && "px-4 py-2.5"}`}
                            key={i}
                            onClick={_ => {onSelect?.(item); setRevealPopOver(false)}}
                        >
                            {
                                formatOpt?.(item) ?? <p
                                                        className="text-grey-2"
                                                    >
                                                        {item.name ?? item?.label ?? item?.title ?? item?.value ?? `${item}`}
                                                    </p>
                            }
                        </button>
                    )
                }
                </div>
            </CustomPopover> 
}

export default CustomInputAutoComplete;